import { http, errorMessageHandler } from "./api.services";
import { toast } from "react-toastify";

export const getBusinessRules = async <T>(queryString?: string) => {
  try {
    const url = `${process.env.VITE_AWS_GET_BUSINESSRULES}${queryString || ""}`;

    const data = await http
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data: data as T };
  } catch (e) {
    console.log(e);
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getBusinessRuleSchema = async () => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_GET_BUSINESSRULES_SCHEMA!, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data };
  } catch (e) {
    console.log(e);
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getExtractionFields = async () => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_GET_BUSINESSRULE_FIELDS!, {
        headers: {
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
export const getBusinessRuleStatus = async () => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_GET_BUSINESSRULE_STATUS!, {
        headers: {
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
export const createRule = async <T>(body: object) => {
  try {
    const data: any = await http
      .post(process.env.VITE_AWS_GET_BUSINESSRULES!, {
        json: { ...body },

        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    toast.success(data?.data || `Business rule created successfully`);
    return { status: true, data: data as T };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const getRule = async (id: string) => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_UPDATE_BUSINESSRULE!.replace("{id}", id), {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();

    return { status: true, data: data };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const editRule = async <T>(body: object, id: string) => {
  try {
    const data = await http
      .put(process.env.VITE_AWS_UPDATE_BUSINESSRULE!.replace("{id}", id), {
        json: { ...body },

        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();
    toast.success(`Business rule updated successfully with ID: ${id}`);
    return { status: true, data: data as T };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const updateRuleStatus = async <T>(status: string, id: string, comment: string | undefined) => {
  try {
    const data = await http
      .patch(process.env.VITE_AWS_UPDATE_RULE_STATUS!.replace("{id}", id), {
        json: {
          status,
          comment
        },

        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();
    toast.success(
      `Business rule with ID: ${id} status updated successfully to ${status}`
    );
    return { status: true, data: data as T };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const uploadBusinessRuleFile = async <T>(fileContent: string) => {
  try {
    const data = await http
      .post(process.env.VITE_AWS_UPLOAD_BUSINESSRULES!, {
        json: {
          file_content: fileContent,
        },
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();
    toast.success(
      `File uploaded successfully`
    );
    return { status: true, data: data as T };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};

export const downloadBusinessRuleResult = async <T>() => {
  try {
    const data = await http
      .get(process.env.VITE_AWS_UPLOAD_BUSINESSRULES!, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.VITE_BASE_API_KEY,
        },
      })
      .json();
    return { status: true, data: data as T };
  } catch (e) {
    await errorMessageHandler(e);
    return { status: false, error: e };
  }
};
